<!--
******************************
 * @author Jesus R. Nava Cruz
 * @date May 25, 2023
 * @version 1.0
******************************
-->
<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" md="6" lg="6">
        <v-text-field
          v-model="model.productKey"
          :counter="100"
          label="Clave de Producto"
          required
          autocomplete="off"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6">
        <v-text-field
          v-model="model.name"
          :counter="700"
          label="Nombre de Producto"
          required
          autocomplete="off"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-textarea
          v-model="model.description"
          :counter="3500"
          label="Description"
          required
          autocomplete="off"
          auto-grow
        ></v-textarea>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "ProductsForm",
  props: {
    model: Object,
  },
  data: () => ({}),
};
</script>